import { yupResolver } from "@hookform/resolvers/yup";
import { TextField } from "@omni/components/components/Form/RHF/FormFields/TextField/Textfield.component";
import { useOmniForm } from "@omni/components/components/Form/RHF/Utils/useOmniForm";
import { useNewsletterContext } from "@omni/components/components/Newsletter/context/newsletter.context";
import {
    NewsletterFormValidationSchema,
    NewsletterFormValues
} from "@omni/components/components/Newsletter/newsletter.schema";
import { useGranite } from "@omni/components/redux/modules/value/translations/translations.provider";
import { FormInfoProvider } from "@omni/components/utils/forms/formInfo.provider";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { FormProvider } from "react-hook-form";

const FORM_ID = "newsLetter";

const FormComponent = () => {
    const { t } = useGranite();
    const { buttonText, onFormSubmit } = useNewsletterContext();

    const methods = useOmniForm({
        mode: "onBlur",
        reValidateMode: "onBlur",
        defaultValues: {
            email: ""
        },
        resolver: yupResolver(NewsletterFormValidationSchema)
    });

    return (
        <FormInfoProvider
            formId={FORM_ID}
            withNeverbounce={true}
        >
            {({ initialized }) => (
                <FormProvider {...methods}>
                    <form
                        id={FORM_ID}
                        onSubmit={methods.handleSubmit(onFormSubmit)}
                    >
                        <div
                            className={cn(
                                "tw:flex tw:flex-wrap tw:items-center tw:gap-3 tw:justify-center tw:md:justify-start"
                            )}
                        >
                            <div
                                className={cn(
                                    "tw:w-full tw:md:w-auto tw:md:grow tw:md:min-w-0"
                                )}
                            >
                                <TextField<NewsletterFormValues>
                                    name="email"
                                    label={t("general.form.email.label")}
                                    required
                                    hideLabel={true}
                                    className={cn(
                                        "tw:rounded-3xl tw:bg-grey tw:h-12 tw:border-0"
                                    )}
                                    hideMicroCopy={true}
                                    placeholder={t(
                                        "general.form.email.placeholder"
                                    )}
                                    autoComplete={"email"}
                                    disabled={!initialized}
                                />
                            </div>
                            <div>
                                <Button
                                    data-test="newsletter-button-submit"
                                    className={cn("tw:mb-4")}
                                    color="primary"
                                    type={"submit"}
                                    disabled={!initialized}
                                >
                                    {buttonText}
                                </Button>
                            </div>
                        </div>
                    </form>
                </FormProvider>
            )}
        </FormInfoProvider>
    );
};

export { FormComponent };
